import type { FC } from "react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

const getErrorCopy = (error: unknown) => {
  if (isRouteErrorResponse(error)) {
    return {
      title: `${error.status} ${error.statusText}`,
      detail: typeof error.data === "string" ? error.data : "The requested page could not be loaded.",
    };
  }

  if (error instanceof Error) {
    return {
      title: "Something went wrong",
      detail: error.message || "The portal hit an unexpected error.",
    };
  }

  return {
    title: "Something went wrong",
    detail: "The portal hit an unexpected error.",
  };
};

export const AppErrorPage: FC = () => {
  const error = useRouteError();
  const { title, detail } = getErrorCopy(error);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#141236] px-4 py-10">
      <section className="w-full max-w-xl rounded-lg border border-white/10 bg-white/5 p-6 text-slate-100 shadow-sm">
        <div className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-full bg-red-500/15 text-red-300">
          <span aria-hidden="true" className="text-xl font-semibold">
            !
          </span>
        </div>
        <p className="text-sm font-medium uppercase text-slate-500">DOCI Portal</p>
        <h1 className="mt-2 text-2xl font-semibold text-white">{title}</h1>
        <p className="mt-3 text-sm leading-6 text-slate-400">{detail}</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-md bg-brand px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-hover focus:outline-none focus:ring-2 focus:ring-brand"
          >
            Retry
          </button>
          <Link
            to="/collections"
            className="rounded-md border border-white/10 px-4 py-2 text-sm font-medium text-slate-200 transition-colors hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-brand"
          >
            Collections
          </Link>
        </div>
      </section>
    </main>
  );
};
